import { render } from "./NavPanel.vue?vue&type=template&id=e791d6dc&ts=true"
import script from "./NavPanel.vue?vue&type=script&lang=ts"
export * from "./NavPanel.vue?vue&type=script&lang=ts"

import "./NavPanel.vue?vue&type=style&index=0&id=e791d6dc&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__